<div class="app-container">
  <app-language-selection
    [selectLangCode]="selectLangCode"
    (selecteLanguge)="onSelectLanguage($event)"
  />
  <router-outlet />
</div>
